var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-item-root-container"},[(_vm.state)?_c('div',{staticClass:"menu-item-selected"}):_vm._e(),_c('img',{staticStyle:{"z-index":"2","width":"22px","height":"22px"},attrs:{"src":_vm.icon}}),_c('div',{staticStyle:{"font-size":"15px","font-weight":"500","color":"#3C3C3C","margin-left":"20px"}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }